export default "__VITE_ASSET__22167898__"